import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';

import { getToken } from '../../../../store/token'
import { getIdCompany } from '../../../../store/company'
import { getIdEmployee } from '../../../../store/employee'
import { getIdUser, getNameUser, getUserLastName } from '../../../../store/user'

import { ConsumerIdData } from './indexModel';
import { ConsumerData } from '../indexModel';

import {
    getShowCreateConsumersModal,
    getShowEditConsumersModal,
    setShowEditConsumersModal,
    getShowEditTicketsModal,
    getShowConfirmationModal,
    setShowEditTicketsModal,
    getSortByList,
    getOrderByList,
    setOrderByList,
    setSortByList,
    setShowAlertFeedback,
} from '../../../../store/internal'

import { AppRequesterController } from '../../../../services/appRequester/appRequesterController';

import BackendConstants from '../../../../core/constants/backend-constants';
import UserService from '../../../../services/user-service';
import { ListName, SortBy } from '../../../../core/enums/order-sort-by';
import { TokenInterface } from '../../../../services/requestsInterfacesModel';
import constsRouters from "../../../../routes/constsRouter";
import ViewConsumers from '.';
import { useTranslation } from 'react-i18next';
import { AgentData } from '../../homeAgents/indexModel';
import useLeaveTicketChat from '../../../../hooks/useLeaveTicketChatSocket';

const AppRequesterConst = new AppRequesterController();

declare module 'react' {
    interface HTMLAttributes<T> extends AriaAttributes, DOMAttributes<T> {
        name?: string;
    }
};

const ViewConsumersController = () => {

    const emp = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { onSocketLeaveTicketChat } = useLeaveTicketChat()

    const values: TokenInterface = {
        company: {
            id: useSelector(getIdCompany)
        },
        employee: {
            id: useSelector(getIdEmployee)
        },
        user: {
            id: useSelector(getIdUser),
            name: useSelector(getNameUser),
            lastname: useSelector(getUserLastName),
        },
        token: {
            value: useSelector(getToken)
        },
        internal: {
            getShowCreateConsumersModal: useSelector(getShowCreateConsumersModal),
            getShowEditConsumersModal: useSelector(getShowEditConsumersModal),
            getShowConfirmationModal: useSelector(getShowConfirmationModal),
            getShowEditTicketsModal: useSelector(getShowEditTicketsModal),
            getSortByList: useSelector(getSortByList),
            getOrderByList: useSelector(getOrderByList),
        }
    };

    const [isLoading, setIsLoading] = useState(false);
    const [currentTicketsConsumers, setCurrentTicketsConsumers] = useState(undefined);
    const [currentConsumer, setCurrentConsumer] = useState(null);
    const [currentFilterSearch, setCurrentFilterSearch] = useState(null);
    const [currentParams, setCurrentParams] = useState({});
    const [aux, setAux] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentLimit, /*SetCurrentLimit*/] = useState(BackendConstants.limitMin);

    const [currentTicket, setCurrentTicket] = useState(null);

    const [currentState, setCurrentState] = useState("");
    const [resetingFilters, setResetingFilters] = useState(false);
    const [yoursTickets, setYoursTickets] = useState(false);
    const [/*currentTotalAllTickets*/, SetCurrentTotalAllTickets] = useState(0);
    const [/*currentTotalYoursTickets*/, SetCurrentTotalYoursTickets] = useState(0);
    const [openModalPhone, setOpenModalPhone] = useState(undefined);
    const [phoneNumber, setPhoneNumber] = useState("");
    const [employeesData, setEmployeesData] = useState([]);

    const [createdByEmployee, setCreatedByEmployee] = useState("");

    // const queryString = window.location.search;
    // const urlParams = new URLSearchParams(queryString);

    const [currentConsumerForSimilarData, setCurrentConsumerForSimilarData] = useState(null);
    const [similarConsumers, setSimilarConsumers] = useState(undefined);
    const [/*currentOrderBy*/, setCurrentOrderBy] = useState(values.internal.getOrderByList);

    const { t } = useTranslation()

    useEffect(() => {
        const controller = new AbortController();
        setCurrentConsumer((state: { name: string; }) => ({
            ...state,
            name: state ? state.name : emp.state['name'],
        }));

        setCreatedByEmployee(emp?.state['created_by_employee']);

        if (currentState === "") {
            if (values.internal.getShowEditTicketsModal === false) {
                setCurrentPage((state) => {
                    setCurrentParams((state2) => {
                        getAllTicketsToPagination(Object.assign(state2, (Object.assign({ user_id: emp.state['user_id'] }, { limit: currentLimit, page: state }))), false);
                        return state2;
                    });
                    return state;
                });
            }
        } else {
            if (values.internal.getShowEditTicketsModal === false) {
                setCurrentPage((state) => {
                    setCurrentParams((state2) => {
                        getAllTicketsToPagination(Object.assign(state2, (Object.assign({ user_id: emp.state['user_id'] }, { limit: currentLimit, page: state }))), true);
                        return state2;
                    });
                    return state;
                });
            }
        }
        return () => {
            controller.abort();
        }
    }, [currentPage, currentState]);

    // useEffect(() => {
    //     const controller = new AbortController();
    //     if (currentState !== "") {
    //         setCurrentConsumer((state: { name: string; }) => ({
    //             ...state,
    //             name: state ? state.name : emp.state['name'],
    //         }));

    //         setCreatedByEmployee(emp?.state['created_by_employee']);

    //         if (values.internal.getShowEditTicketsModal === false) {
    //             setCurrentPage((state) => {
    //                 setCurrentParams((state2) => {
    //                     getAllTicketsToPagination(Object.assign(state2, (Object.assign({ user_id: emp.state['user_id'] }, { limit: currentLimit, page: state }))), true);
    //                     return state2;
    //                 });
    //                 return state;
    //             });
    //         }

    //         return () => {
    //             controller.abort();
    //         }
    //     }
    // }, [currentState]);

    const getConsumer = async (userID: string) => {
        const headers = UserService.getHeaders()

        await AppRequesterConst.Get(
            '/consumer/' + userID, { headers },
            (response: Object) => {

            },
            (data: ConsumerIdData) => {
                if (data.status === 200) {

                    setCurrentConsumer({
                        address: data.data.consumers[0].address,
                        id: data.data.consumers[0].id,
                        user_id: userID,
                        name: data.data.consumers[0].name + " " + (data.data.consumers[0].name && data.data.consumers[0].lastname ? data.data.consumers[0].lastname : ""),
                        document_number: data.data.consumers[0].document_number,
                        company_id: data.data.consumers[0].company_id,
                        company_number: data.data.consumers[0].company_number,
                        email: data.data.consumers[0].email,
                        facebook: data.data.consumers[0].facebook,
                        instagram: data.data.consumers[0].instagram,
                        lastname: data.data.consumers[0].lastname,
                        observations: data.data.consumers[0].observations,
                        phone: data.data.consumers[0].phone,
                        twitter: data.data.consumers[0].twitter,
                        whatsapp: data.data.consumers[0].whatsapp,
                        custom: data.data.consumers[0].custom_fields,
                        employee_user_id: data.data.consumers[0].employee_user_id,
                        tags: data.data.consumers[0].tags
                    });
                }
            },
            (error: Object) => {
                console.log(error);
            }, navigate, dispatch, setIsLoading, { values: values }
        );
    }

    const getAllTickets = async (params: { user_id: string; } & { limit: number; page: number; }, setData: Function, aux: any[], setAux: Function, filter) => {
        if (
            values.internal.getSortByList.listName === ListName.ListOfTickets &&
            (values.internal.getSortByList.sort_by !== null && (values.internal.getSortByList.sort_by === SortBy.updated_level2_date || values.internal.getSortByList.sort_by === SortBy.home_ticket_update_at)) &&
            values.internal.getOrderByList !== null
        ) {
            params = Object.assign(params, { sort_by: values.internal.getSortByList.sort_by, order_by: values.internal.getOrderByList });
        }
        const headers = UserService.getHeaders() /*,signal = controller.signal*/;

        await AppRequesterConst.Get(
            '/consumer/' + params.user_id + '/tickets', { headers, /*signal,*/ params: params },
            (response: Object) => { },
            (data: ConsumerData) => {
                if (data.status === 200 && data.data.tickets) {
                    setValuesOfNumbersTickets(data.data.total, data.data.total_my_tickets);
                    setAux((state: any[]) => {
                        let aux = state?.concat(data.data.tickets);
                        setAux(aux);
                        setData(aux);
                        return state;
                    });
                } else if (data.status === 204 && filter) {

                    dispatch(setShowAlertFeedback({ message: t('home_tags.view_tag_tickets_204'), visibility: true, signalIcon: false }))
                    setData([])
                }
                else if (aux.length === 0) {
                    setData(undefined);
                }
            },
            (error: Object) => { }, navigate, dispatch, setIsLoading, { values: values }
        );
    }

    const updateListfunction = () => {
        setCurrentPage(currentPage + 1);
    };

    const updateListAfterDelete = () => {
        setAux([]);
        setCurrentPage(1);
        setCurrentTicketsConsumers(undefined);

        setCurrentState("deleting");

        if (currentState === "deleting") {
            setCurrentState("");
        }
    };

    const getAllTicketsToPagination = (params: { user_id: string; } & { limit: number; page: number; }, filter) => {
        getAllTickets(params, setCurrentTicketsConsumers, aux, setAux, filter);
    }

    const setValuesOfNumbersTickets = (totalAllTickets: number, totalYoursTickets: number) => {
        SetCurrentTotalAllTickets(totalAllTickets)
        SetCurrentTotalYoursTickets(totalYoursTickets)
    }

    const showEditModal = () => {
        setCurrentPage(1);
        setAux([]);
        getConsumer(emp.state['user_id']).finally(() => {
            setCurrentState("editing");

            if (currentState === "editing") {
                setCurrentState("");
            }
            dispatch(setShowEditConsumersModal(true));
        })
        // getAllEmployees()
    }

    const listOfConsumersPage = () => {
        if (values.internal.getShowEditTicketsModal === false) {
            navigate(constsRouters.routers.consumers.path);
        } else {
            onSocketLeaveTicketChat(currentTicket?.id)
            dispatch(setShowEditTicketsModal(false));
            setCurrentPage(1);
            setAux([]);
            setCurrentTicketsConsumers(undefined);
            setCurrentParams({});
            setResetingFilters(true);

            setCurrentState("returning");
            if (currentState === "returning") {
                setCurrentState("");
            }
        }
    }

    const setCurrentTicketFunction = (value: any) => {
        setCurrentTicket({id: value.id.split("*ID*")[0].split("*who_is_viewing*")[0]});
    }

    const filteringTickets = (e: { currentTarget: { id: string; }; }, auxObj: Object, action: string) => {
        setCurrentPage(1);
        setAux([]);
        setCurrentTicketsConsumers(undefined);

        if (document.getElementById("listOfTickets") != null) {
            document.getElementById("listOfTickets").scrollTop = 0;
        }

        if (action === "clean") {
            setCurrentFilterSearch("");
            auxObj = {};
            setCurrentState("searching");
            if (currentState === "searching") {
                setCurrentState("");
            }
        } else if (e.currentTarget.id === "searchButton" || e.currentTarget.id === "SearchInput") {
            auxObj = {};
            setCurrentState("searching");

            if (currentState === "searching") {
                setCurrentState("");
            }

            if (currentFilterSearch !== null && currentFilterSearch !== "") {
                auxObj["search"] = currentFilterSearch;
            }

        } else {
            setCurrentState("filtering");

            if (currentState === "filtering") {
                setCurrentState("");
            }
        }

        dispatch(setShowEditTicketsModal(false));

        setCurrentParams(auxObj);
    }

    const cleanList = () => {
        setCurrentParams({});
        setCurrentPage(1);
        setAux([]);
        setCurrentTicketsConsumers(undefined);
        setResetingFilters(true);

        setCurrentState("filtering");

        if (currentState === "filtering") {
            setCurrentState("");
        }
    }

    const showCreateTicket = () => {
        navigate(constsRouters.routers.createTicket.path);
    }

    const callbackOrderByTickets = (column: any, order: any) => {
        setCurrentPage(1);
        setAux([]);
        setCurrentState(column + order);
        setCurrentOrderBy(order);
        
        dispatch(setOrderByList(order));
        dispatch(setSortByList({ sort_by: column === SortBy.updated_level2_date? SortBy.updated_level2_date: column === SortBy.home_ticket_update_at ? SortBy.home_ticket_update_at : SortBy.updated_level2_date, listName: ListName.ListOfTickets }));
        
        if (document.getElementById(ListName.ListOfTickets)) {
            document.getElementById(ListName.ListOfTickets).scrollTop = 0;
        }
    }

    const callbackModalCustomers = () => {
        setCurrentPage(1);
        setAux([]);
        getConsumer(emp.state['user_id']).finally(() => {
            setCurrentState("editing");

            if (currentState === "editing") {
                setCurrentState("");
            }
        });

        getConsumer(emp.state['user_id'])
    }

    // const getAllEmployees = async () => {

    //     const headers = UserService.getHeaders()

    //     await AppRequesterConst.Get(
    //         `/agent`, { headers },
    //         (response: Object) => { },
    //         (data: AgentData) => {
    //             if (data.data && data.status == 200) {
    //                 setEmployeesData(data.data.employees.map((item) => {
    //                     return { label: item.name, value: item.user_id }
    //                 }))
    //             }
    //         },
    //         (error: { response: { status: number; data: { code_cxpress: number } } }) => {

    //         }, navigate, dispatch, setIsLoading, { values: values }
    //     )
    // }

    return <ViewConsumers
        values={values}
        currentConsumer={currentConsumer}
        setCurrentConsumerForSimilarData={setCurrentConsumerForSimilarData}
        setSimilarConsumers={setSimilarConsumers}
        currentConsumerForSimilarData={currentConsumerForSimilarData}
        similarConsumers={similarConsumers}
        callbackModalCustomers={callbackModalCustomers}
        callbackOrderByTickets={callbackOrderByTickets}
        currentTicketsConsumers={currentTicketsConsumers}
        currentTicket={currentTicket}
        currentParams={currentParams}
        setCurrentFilterSearch={setCurrentFilterSearch}
        currentFilterSearch={currentFilterSearch}
        currentState={currentState}
        setCurrentState={setCurrentState}
        yoursTickets={yoursTickets}
        setYoursTickets={setYoursTickets}
        filteringTickets={filteringTickets}
        cleanList={cleanList}
        getAllTickets={getAllTickets}
        updateListAfterDelete={updateListAfterDelete}
        updateListfunction={updateListfunction}
        showCreateTicket={showCreateTicket}
        listOfConsumersPage={listOfConsumersPage}
        showEditModal={showEditModal}
        resetingFilters={resetingFilters}
        setResetingFilters={setResetingFilters}
        isLoading={isLoading}
        phoneNumber={phoneNumber}
        openModalPhone={openModalPhone}
        setOpenModalPhone={setOpenModalPhone}
        setPhoneNumber={setPhoneNumber}
        setCurrentTicketFunction={setCurrentTicketFunction}
        t={t}
        employeesData={employeesData}
        createdByEmployee={createdByEmployee}
    />

}

export default ViewConsumersController;